import React, { Component } from 'react';
import './Common.css';
import './DropdownMenu.css';

class DropdownMenu extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleKeyboard = this.handleKeyboard.bind(this);
        this.state = { open: false, keyboardItem: 0 };
        this.node = null;
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick, false);
        document.addEventListener("keydown", this.handleKeyboard, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick, false);
        document.removeEventListener("keydown", this.handleKeyboard, false);
    }

    handleKeyboard(event){

        if(this.state.open === true) {

            let count = Math.max(1, this.props.list.length);
            let keyboardItem = this.state.keyboardItem;

            if(event.keyCode === 27) {
                this.setState({open: false});
            }
            else if(event.keyCode === 38 || event.keyCode === 37) {
                keyboardItem = (keyboardItem + count - 1) % count;
                this.setState({keyboardItem: keyboardItem});
            }
            else if(event.keyCode === 40 || event.keyCode === 39) {
                keyboardItem = (keyboardItem + 1) % count;
                this.setState({keyboardItem: keyboardItem});
            }
            else if(event.keyCode === 32 || event.keyCode === 13) {

                let entryList = this.props.list;
                if(keyboardItem < entryList.length) {
                    let selectedName = entryList[keyboardItem].name;
                    this.props.onChange(selectedName);
                    this.setState({open: false});
                }
            }
    
            event.preventDefault();
        }
    }

    handleOutsideClick(event) {
        if(this.node.contains(event.target)) {
            return;
        }

        this.setState({open: false});
    }

    handleItemClick(event) {
        this.props.onChange(event.target.getAttribute("name"));
        this.setState({open: false});
    }

    handleToggleClick(event) {

        let initialKeyboardItem = 0;
        let selectedName = this.props.selected;
        let entryList = this.props.list;

        for(let i=0; i<entryList.length; i++) {
            if(entryList[i].name === selectedName) {
                initialKeyboardItem = i;
            }
        }

        let open = this.state.open || false;
        this.setState({open: !open, keyboardItem: initialKeyboardItem});
    }

    render() {  

        let open = this.state.open || false;
        let entryList = this.props.list;

        /*
        entryList.push({name:"1", text:"Version 1: @ethgeek on 11/12/2018"});
        entryList.push({name:"2", text:"Version 2: @ethgeek on 11/13/2018"});
        entryList.push({name:"3", text:"Version 3: @ethgeek on 11/14/2018"});
        entryList.push({name:"4", text:"Version 4: @ethgeek on 11/15/2018"});
        entryList.push({name:"5", text:"Version 5: @ethgeek on 11/16/2018"});
        */

        let selectedEntry = entryList[0];
        let selectedName = this.props.selected;
        for(let i=0; i<entryList.length; i++) {
            if(entryList[i].name === selectedName) {
                selectedEntry = entryList[i];
            }
        }

        return (
            <div ref={node => this.node = node} className="menuContainer">
                <div onClick={this.handleToggleClick} className={"menuTitle" + (open ? " menuTitleOpen" : "")}>{selectedEntry.text} <div className="menuArrow">&#x25BC;</div></div>
                <table className={"menuDropdown" + (open ? "" : " hide")}><tbody>
                    {
                        entryList.map((entry, index) => {
                            return (<tr key={index}><td name={entry.name} onClick={this.handleItemClick} className={"menuItem" + (index === this.state.keyboardItem ? " menuItemKeyboard" : "")}>{entry.text}</td></tr>);
                        })
                    }
                    

                </tbody></table>
            </div>
        );
    }
  }
  
  export default DropdownMenu;


// WEBPACK FOOTER //
// ./src/components/DropdownMenu.js